import { useState } from 'react';
import { Logo } from '@/components';

const VIDEO = '/entrada.mp4';

function prefereParado(): boolean {
  return (
    typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}

/**
 * O painel de entrada: um salao em movimento, atras da marca. No celular e
 * so a faixa de cima - nitida no topo, sumindo num degrade ate o branco do
 * formulario, com a marca flutuando por cima da metade de baixo do video. No
 * desktop vira a coluna inteira da esquerda, sem texto nem logo por cima -
 * a marca ali mora no formulario, ao lado.
 *
 * O azulado da cor da marca fica por baixo do video: enquanto ele carrega, e
 * para quem pediu ao sistema para nao animar nada, a faixa ja esta pintada.
 */
export function AuthBackdrop() {
  const [anima] = useState(() => !prefereParado());

  return (
    <div className="relative h-48 shrink-0 overflow-hidden bg-primary sm:h-60 lg:h-auto lg:w-[46%]">
      {anima ? (
        <video
          className="absolute inset-0 h-full w-full object-cover"
          src={VIDEO}
          autoPlay
          loop
          muted
          playsInline
          aria-hidden
        />
      ) : null}

      {/* So no celular: o video vai sumindo num degrade ate o fundo da
          pagina, e a marca flutua sobre a metade de baixo dele. No desktop
          o video fica nitido a coluna inteira, sem nada por cima. */}
      <div
        aria-hidden
        className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-background to-transparent lg:hidden"
      />
      <div className="absolute inset-x-0 bottom-0 flex justify-center pb-6 lg:hidden">
        <Logo className="h-[3.25rem] drop-shadow-[0_2px_6px_rgba(0,0,0,0.35)]" />
      </div>
    </div>
  );
}
